export const ISSUE_CREATE_COMMONS_INPUT_FIELD_TEST_ID =
	'issue-create-commons.common.ui.fields.base-fields.input-field.textfield';
